import React, { Component } from "react";
import { Button, Card } from "antd";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getFirebaseData } from "../../redux/actions/network";
import { connect } from "react-redux";

class ProfessorActions extends Component {
  componentDidMount() {
    this.props.getFirebaseData();
  }

  render() {
    return (
      <div>
        <Card>
          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="success">
              <Link to="/alumnos">Ver lista de Usuarios</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="info">
              <Link to="/grupos">Ver grupos de Alumnos</Link>
            </Button>
          </Card.Grid>
        </Card>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getFirebaseData }, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(ProfessorActions);
